import { render, staticRenderFns } from "./TK037MemberTeikiIkkatuTdkList.vue?vue&type=template&id=06d341f8&"
import script from "./TK037MemberTeikiIkkatuTdkList.vue?vue&type=script&lang=js&"
export * from "./TK037MemberTeikiIkkatuTdkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports